import React, { useEffect } from "react";

const CMSCrl8GalleryView = ({ containerId = "gallery-z5pfqsx0" }) => {
  useEffect(() => {
    if (window.crl8 && typeof window.crl8.ready === "function") {
      window.crl8.ready(() => {
        console.log(`Curalate gallery initialized for container: ${containerId}`);
      });
    } else {
      console.warn("Curalate script not found on window. Did you add it to <head>?");
    }
  }, [containerId]);

  return <div data-crl8-container-id={containerId}></div>;
};

export default CMSCrl8GalleryView;
